export default __webpack_public_path__ + "static/media/publiccontests.dae88ba5.PNG";